import { useEffect, useState } from 'react';
import {
  useCollectionComponentsStandAloneLookups,
  useComponentComponentsLookups,
  useContentEntityTypesLookups,
  useGetContentEntityTypeNavigationById,
} from '@wajeez-web/components/helpers';
import { Spin } from '@wajeez-web/components/ui';
import { ReturnTranslatedText } from '@wajeez-web/core/localization';
import {
  clearContentEntityTypeNavigationById,
  getCollectionComponentsStandAloneLookups,
  getComponentComponentsLookups,
  getContentEntityTypeNavigationById,
  getContentEntityTypesLookups,
} from '@wajeez-web/stores/content';
import { useParams } from 'react-router-dom';
import { ContentEntityTypeNavigationFormBuilder } from '../components/ContentEntityTypeNavigationFormBuilder';

export const CreateAndEditContentEntityTypeNavigationPage = () => {
  const { id } = useParams<{ id: string }>();

  const [
    isComponentComponentsLookupsSuccess,
    setIsComponentComponentsLookupsSuccess,
  ] = useState(false);
  const [
    isCollectionComponentsStandAloneLookupsSuccess,
    setIsCollectionComponentsStandAloneLookupsSuccess,
  ] = useState(false);

  const contentEntityTypesLookups = useContentEntityTypesLookups();

  const componentComponentsLookups = useComponentComponentsLookups();

  const collectionComponentsStandAloneLookups =
    useCollectionComponentsStandAloneLookups();

  const contentEntityTypeNavigationById =
    useGetContentEntityTypeNavigationById();

  useEffect(() => {
    getContentEntityTypesLookups();

    getComponentComponentsLookups({}, () => {
      setIsComponentComponentsLookupsSuccess(true);
    });

    getCollectionComponentsStandAloneLookups({}, () => {
      setIsCollectionComponentsStandAloneLookupsSuccess(true);
    });
  }, []);

  useEffect(() => {
    if (id) {
      getContentEntityTypeNavigationById(Number(id));
    }

    return () => {
      clearContentEntityTypeNavigationById();
    };
  }, [id]);

  const isLoading =
    contentEntityTypesLookups.status === 'loading' ||
    (componentComponentsLookups.status === 'loading' &&
      !isComponentComponentsLookupsSuccess) ||
    (collectionComponentsStandAloneLookups.status === 'loading' &&
      !isCollectionComponentsStandAloneLookupsSuccess) ||
    contentEntityTypeNavigationById.status === 'loading';

  const pageTitle = (!id ? 'Create' : 'Edit') + ' Type Navigation';

  return (
    <div className="p-4 rtl:pl-8 ltr:pr-8">
      <h1 className="text-[26px] font-bold text-center">
        <ReturnTranslatedText
          text={`pageHeader.${pageTitle}`}
          origintext={pageTitle}
        />
      </h1>
      {isLoading ? (
        <div className="w-full pt-[200px]">
          <Spin />
        </div>
      ) : (
        ((id && contentEntityTypeNavigationById.data) ||
          (!id && !contentEntityTypeNavigationById.data)) && (
          <ContentEntityTypeNavigationFormBuilder
            id={id}
            data={contentEntityTypeNavigationById.data}
          />
        )
      )}
    </div>
  );
};
